import request from './request';

/**
 * 获取统计数据
 * @param {Object} params - { startDate, endDate }
 */
export function getExecutionPlanStats(params) {
  return request({
    url: '/execution-plan-stats',
    method: 'get',
    params
  });
}

/**
 * 手动触发汇总
 * @param {Object} data - { startDate, endDate }
 */
export function aggregateExecutionPlanStats(data) {
  return request({
    url: '/execution-plan-stats/aggregate',
    method: 'post',
    data
  });
}
